module.exports = __webpack_public_path__ + "static/media/uaveiro.768b9eb8.webp";